import React, { FunctionComponent } from 'react';
import StatsList, { StatsListItem } from '../../../components/stats-list/StatsList';
import PageSection from '../../../components/page-section/PageSection';
import { TextAlign } from '../../../types';

export interface StatsSectionProps {
  title: string,
  description?: string,
  items: StatsListItem[],
}

const StatsSection: FunctionComponent<StatsSectionProps> = ({
  title,
  description,
  items,
}) => (
  <PageSection>
    <PageSection.Wrapper>
      <PageSection.Title textAlign={TextAlign.CENTER}>
        {title}
      </PageSection.Title>
      <PageSection.Description text={description} textAlign={TextAlign.CENTER} />
      <PageSection.Block>
        <StatsList items={items} />
      </PageSection.Block>
    </PageSection.Wrapper>
  </PageSection>
);

export default StatsSection;
